import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { TaskListCallbackStoreContract } from '../interfaces';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterTaskListCallBack extends Callback<Array<FilterUsers>> {
	public constructor(private readonly store: TaskListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setFilterUsers(successResponse);
	};
}
